// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: chat_session.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisTreeProto } from "./analysis";
import { AnalysisPlanProto } from "./analysis_plan";
import {
  ChatMessageType,
  chatMessageTypeFromJSON,
  chatMessageTypeToJSON,
  DarwinAgentType,
  darwinAgentTypeFromJSON,
  darwinAgentTypeToJSON,
  DarwinHeader,
} from "./common";
import { CustomAgentProto } from "./custom_agent";

export const protobufPackage = "com.anko.darwin";

/** Client types */
export enum ChatClientType {
  UNKNOWN_CLIENT_TYPE = 0,
  EVA = 1,
  FRIDA = 2,
  SLACK = 3,
  SCHEDULED = 4,
  UNRECOGNIZED = -1,
}

export function chatClientTypeFromJSON(object: any): ChatClientType {
  switch (object) {
    case 0:
    case "UNKNOWN_CLIENT_TYPE":
      return ChatClientType.UNKNOWN_CLIENT_TYPE;
    case 1:
    case "EVA":
      return ChatClientType.EVA;
    case 2:
    case "FRIDA":
      return ChatClientType.FRIDA;
    case 3:
    case "SLACK":
      return ChatClientType.SLACK;
    case 4:
    case "SCHEDULED":
      return ChatClientType.SCHEDULED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatClientType.UNRECOGNIZED;
  }
}

export function chatClientTypeToJSON(object: ChatClientType): string {
  switch (object) {
    case ChatClientType.UNKNOWN_CLIENT_TYPE:
      return "UNKNOWN_CLIENT_TYPE";
    case ChatClientType.EVA:
      return "EVA";
    case ChatClientType.FRIDA:
      return "FRIDA";
    case ChatClientType.SLACK:
      return "SLACK";
    case ChatClientType.SCHEDULED:
      return "SCHEDULED";
    case ChatClientType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ChatMessageProto {
  /** Message type */
  message_type?:
    | ChatMessageType
    | undefined;
  /** Content for simple messages (SYSTEM, HUMAN, RESPONSE) */
  content?:
    | string
    | undefined;
  /** For REASONING type: embedded child conversation as JSON strings */
  langgraph_message_json_list: string[];
  /**
   * Artifacts: map of index -> Artifact (relative to base_messages)
   * TODO: Map the artifacts to the index in langgraph message array.
   */
  artifacts: ArtifactProto[];
}

/** Artifact: metadata about accessed resources */
export interface ArtifactProto {
  /** Tool name */
  tool_name?:
    | string
    | undefined;
  /** Parameters used in the tool call (as JSON string) */
  params?:
    | string
    | undefined;
  /** Additional metadata (as JSON string) */
  metadata?: string | undefined;
}

/** This is the master proto for inputs of all agents. */
export interface AgentInputProto {
  trees: AnalysisTreeProto[];
  plans: AnalysisPlanProto[];
  custom_agents: CustomAgentProto[];
}

export interface ChatResponse {
  chat_id?: string | undefined;
  messages: ChatMessageProto[];
}

/** Chat request message for starting/continuing conversations */
export interface ChatRequest {
  /** agent type */
  agent_type?:
    | DarwinAgentType
    | undefined;
  /** Client type */
  client_type?:
    | ChatClientType
    | undefined;
  /** Agent header */
  agent_header?:
    | DarwinHeader
    | undefined;
  /** Prompt header */
  prompt_header?:
    | DarwinHeader
    | undefined;
  /** Agent input */
  agent_input?:
    | AgentInputProto
    | undefined;
  /** User message */
  message?:
    | string
    | undefined;
  /** Optional session ID */
  session_id?: string | undefined;
}

function createBaseChatMessageProto(): ChatMessageProto {
  return { message_type: undefined, content: undefined, langgraph_message_json_list: [], artifacts: [] };
}

export const ChatMessageProto: MessageFns<ChatMessageProto> = {
  encode(message: ChatMessageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message_type !== undefined) {
      writer.uint32(8).int32(message.message_type);
    }
    if (message.content !== undefined) {
      writer.uint32(18).string(message.content);
    }
    for (const v of message.langgraph_message_json_list) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.artifacts) {
      ArtifactProto.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMessageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMessageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.message_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.langgraph_message_json_list.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMessageProto {
    return {
      message_type: isSet(object.message_type) ? chatMessageTypeFromJSON(object.message_type) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      langgraph_message_json_list: globalThis.Array.isArray(object?.langgraph_message_json_list)
        ? object.langgraph_message_json_list.map((e: any) => globalThis.String(e))
        : [],
      artifacts: globalThis.Array.isArray(object?.artifacts)
        ? object.artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatMessageProto): unknown {
    const obj: any = {};
    if (message.message_type !== undefined) {
      obj.message_type = chatMessageTypeToJSON(message.message_type);
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.langgraph_message_json_list?.length) {
      obj.langgraph_message_json_list = message.langgraph_message_json_list;
    }
    if (message.artifacts?.length) {
      obj.artifacts = message.artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMessageProto>, I>>(base?: I): ChatMessageProto {
    return ChatMessageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMessageProto>, I>>(object: I): ChatMessageProto {
    const message = createBaseChatMessageProto();
    message.message_type = object.message_type ?? undefined;
    message.content = object.content ?? undefined;
    message.langgraph_message_json_list = object.langgraph_message_json_list?.map((e) => e) || [];
    message.artifacts = object.artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseArtifactProto(): ArtifactProto {
  return { tool_name: undefined, params: undefined, metadata: undefined };
}

export const ArtifactProto: MessageFns<ArtifactProto> = {
  encode(message: ArtifactProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tool_name !== undefined) {
      writer.uint32(10).string(message.tool_name);
    }
    if (message.params !== undefined) {
      writer.uint32(18).string(message.params);
    }
    if (message.metadata !== undefined) {
      writer.uint32(26).string(message.metadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tool_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.params = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactProto {
    return {
      tool_name: isSet(object.tool_name) ? globalThis.String(object.tool_name) : undefined,
      params: isSet(object.params) ? globalThis.String(object.params) : undefined,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : undefined,
    };
  },

  toJSON(message: ArtifactProto): unknown {
    const obj: any = {};
    if (message.tool_name !== undefined) {
      obj.tool_name = message.tool_name;
    }
    if (message.params !== undefined) {
      obj.params = message.params;
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArtifactProto>, I>>(base?: I): ArtifactProto {
    return ArtifactProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArtifactProto>, I>>(object: I): ArtifactProto {
    const message = createBaseArtifactProto();
    message.tool_name = object.tool_name ?? undefined;
    message.params = object.params ?? undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseAgentInputProto(): AgentInputProto {
  return { trees: [], plans: [], custom_agents: [] };
}

export const AgentInputProto: MessageFns<AgentInputProto> = {
  encode(message: AgentInputProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trees) {
      AnalysisTreeProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.plans) {
      AnalysisPlanProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.custom_agents) {
      CustomAgentProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trees.push(AnalysisTreeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plans.push(AnalysisPlanProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.custom_agents.push(CustomAgentProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputProto {
    return {
      trees: globalThis.Array.isArray(object?.trees) ? object.trees.map((e: any) => AnalysisTreeProto.fromJSON(e)) : [],
      plans: globalThis.Array.isArray(object?.plans) ? object.plans.map((e: any) => AnalysisPlanProto.fromJSON(e)) : [],
      custom_agents: globalThis.Array.isArray(object?.custom_agents)
        ? object.custom_agents.map((e: any) => CustomAgentProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgentInputProto): unknown {
    const obj: any = {};
    if (message.trees?.length) {
      obj.trees = message.trees.map((e) => AnalysisTreeProto.toJSON(e));
    }
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => AnalysisPlanProto.toJSON(e));
    }
    if (message.custom_agents?.length) {
      obj.custom_agents = message.custom_agents.map((e) => CustomAgentProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputProto>, I>>(base?: I): AgentInputProto {
    return AgentInputProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputProto>, I>>(object: I): AgentInputProto {
    const message = createBaseAgentInputProto();
    message.trees = object.trees?.map((e) => AnalysisTreeProto.fromPartial(e)) || [];
    message.plans = object.plans?.map((e) => AnalysisPlanProto.fromPartial(e)) || [];
    message.custom_agents = object.custom_agents?.map((e) => CustomAgentProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChatResponse(): ChatResponse {
  return { chat_id: undefined, messages: [] };
}

export const ChatResponse: MessageFns<ChatResponse> = {
  encode(message: ChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat_id !== undefined) {
      writer.uint32(10).string(message.chat_id);
    }
    for (const v of message.messages) {
      ChatMessageProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(ChatMessageProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatResponse {
    return {
      chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => ChatMessageProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatResponse): unknown {
    const obj: any = {};
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => ChatMessageProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatResponse>, I>>(base?: I): ChatResponse {
    return ChatResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse>, I>>(object: I): ChatResponse {
    const message = createBaseChatResponse();
    message.chat_id = object.chat_id ?? undefined;
    message.messages = object.messages?.map((e) => ChatMessageProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChatRequest(): ChatRequest {
  return {
    agent_type: undefined,
    client_type: undefined,
    agent_header: undefined,
    prompt_header: undefined,
    agent_input: undefined,
    message: undefined,
    session_id: undefined,
  };
}

export const ChatRequest: MessageFns<ChatRequest> = {
  encode(message: ChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_type !== undefined) {
      writer.uint32(8).int32(message.agent_type);
    }
    if (message.client_type !== undefined) {
      writer.uint32(16).int32(message.client_type);
    }
    if (message.agent_header !== undefined) {
      DarwinHeader.encode(message.agent_header, writer.uint32(26).fork()).join();
    }
    if (message.prompt_header !== undefined) {
      DarwinHeader.encode(message.prompt_header, writer.uint32(34).fork()).join();
    }
    if (message.agent_input !== undefined) {
      AgentInputProto.encode(message.agent_input, writer.uint32(42).fork()).join();
    }
    if (message.message !== undefined) {
      writer.uint32(50).string(message.message);
    }
    if (message.session_id !== undefined) {
      writer.uint32(58).string(message.session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.client_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.agent_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.prompt_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.agent_input = AgentInputProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatRequest {
    return {
      agent_type: isSet(object.agent_type) ? darwinAgentTypeFromJSON(object.agent_type) : undefined,
      client_type: isSet(object.client_type) ? chatClientTypeFromJSON(object.client_type) : undefined,
      agent_header: isSet(object.agent_header) ? DarwinHeader.fromJSON(object.agent_header) : undefined,
      prompt_header: isSet(object.prompt_header) ? DarwinHeader.fromJSON(object.prompt_header) : undefined,
      agent_input: isSet(object.agent_input) ? AgentInputProto.fromJSON(object.agent_input) : undefined,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      session_id: isSet(object.session_id) ? globalThis.String(object.session_id) : undefined,
    };
  },

  toJSON(message: ChatRequest): unknown {
    const obj: any = {};
    if (message.agent_type !== undefined) {
      obj.agent_type = darwinAgentTypeToJSON(message.agent_type);
    }
    if (message.client_type !== undefined) {
      obj.client_type = chatClientTypeToJSON(message.client_type);
    }
    if (message.agent_header !== undefined) {
      obj.agent_header = DarwinHeader.toJSON(message.agent_header);
    }
    if (message.prompt_header !== undefined) {
      obj.prompt_header = DarwinHeader.toJSON(message.prompt_header);
    }
    if (message.agent_input !== undefined) {
      obj.agent_input = AgentInputProto.toJSON(message.agent_input);
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.session_id !== undefined) {
      obj.session_id = message.session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatRequest>, I>>(base?: I): ChatRequest {
    return ChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatRequest>, I>>(object: I): ChatRequest {
    const message = createBaseChatRequest();
    message.agent_type = object.agent_type ?? undefined;
    message.client_type = object.client_type ?? undefined;
    message.agent_header = (object.agent_header !== undefined && object.agent_header !== null)
      ? DarwinHeader.fromPartial(object.agent_header)
      : undefined;
    message.prompt_header = (object.prompt_header !== undefined && object.prompt_header !== null)
      ? DarwinHeader.fromPartial(object.prompt_header)
      : undefined;
    message.agent_input = (object.agent_input !== undefined && object.agent_input !== null)
      ? AgentInputProto.fromPartial(object.agent_input)
      : undefined;
    message.message = object.message ?? undefined;
    message.session_id = object.session_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
